/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'openIdProviderName',
  standalone: true,
})
export class OpenIdProviderNamePipe implements PipeTransform {
  transform(value: string) {
    switch (value) {
      case 'google':
        return 'Google';
      case 'microsoft':
        return 'Microsoft';
      case 'okta':
        return 'Okta';
      case 'yahoo':
        return 'Yahoo';
      case 'github':
        return 'Github';
      case 'apple':
        return 'Apple';
      default:
        return value;
    }
  }
}
